import { styled } from '@mui/material/styles';
import { Theme } from "@mui/material";

import {  tooltipClasses, Typography } from "@mui/material";

export const TooltipStyles = (theme: Theme) => {
  return ({
    [`& .${tooltipClasses.tooltip}`]: {
      background: '#FCFCFC',
      color: '#070707',
      border: '0.25rem solid #FCFCFC',
      borderRadius: '1rem',
      boxShadow: '0px 16px 64px 0px #000',

      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '0.5rem',
      maxWidth: '17.125rem',
      padding: '1.5rem',
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: '#FCFCFC',
      fontSize: '2rem',
    },
  })
};

export const TooltipHeader = styled(Typography)(({ theme }) => ({
  alignSelf: 'stretch',

  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.md,
  fontStyle: 'normal',
  fontWeight: theme.fontWeights.semibold,
  lineHeight: theme.lineHeights.slim,
}));

export const TooltipBody = styled(Typography)(({ theme }) => ({
  alignSelf: 'stretch',

  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.sm,
  fontStyle: 'normal',
  fontWeight: theme.fontWeights.regular,
  lineHeight: theme.lineHeights.base,

  '& a': {
    color: '#0C44FF',
  },
}));